module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    staticClass: "form-control",
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cfdb15e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextareaInput.vue
// module id = 447
// module chunks = 1